import { isWithinCustomerCenterView } from './cf_utils'
import { matchesAction } from './utils/action_matching'

const internalLinks = [
  '#open-popup',
  '#close-popup',
  '#submit-form',
  '#scroll',
  '#print',
  '#show-hide',
  '#download-asset',
  '#download-inline',
]

function setupActionLinkListeners() {
  // Action hrefs match on how they END (a[href$=...]) because marketing tags
  // decorate anchor hrefs by prepending an absolute URL and query string in
  // front of the fragment; an exact [href='#action'] selector stops matching
  // the moment that happens. data-element-link is ours and never decorated, so
  // it matches exactly. matchesAction() then rejects genuine links to OTHER
  // pages that merely end in the action fragment.

  // Print Page (webinars)
  $(document).on('click', "[data-element-link='#print'], a[href$='#print']", function (evt) {
    if (!matchesAction(evt.currentTarget, '#print')) return

    window.print()

    return false
  })

  $(document).on('click', "[data-element-link='#open-popup'], a[href$='#open-popup']", function (evt) {
    if (!matchesAction(evt.currentTarget, '#open-popup')) return

    // Prevent the navigation unconditionally, before anything below can throw or
    // bail out. A decorated href turns "we didn't handle this click" into a full
    // page reload, so falling through is never the safe default.
    evt.preventDefault()

    // NOTE: `data-elbuttontype` lives on the `.elBTN` wrapper, but `evt.target`
    // is the innermost clicked node (usually a `<span>` inside the anchor), so
    // this lookup almost never finds the attribute and the popup opens. Reading
    // it off the right element would change which buttons open a popup, which is
    // out of scope here — this keeps today's behavior while making the optional
    // chain stop a null `parentElement` from throwing and falling through to a
    // native navigation.
    const checkIfShowHide = (evt.target as Element).parentElement?.getAttribute('data-elbuttontype')
    if (typeof checkIfShowHide == 'undefined' || !['2', 'showHide'].includes(checkIfShowHide)) {
      globalThis.CFOpenPopup()
    }
  })

  $(document).on('click', "[data-element-link='#close-popup'], a[href$='#close-popup']", function (evt) {
    if (!matchesAction(evt.currentTarget, '#close-popup')) return

    evt.preventDefault()
    globalThis.CFClosePopup()
  })

  // Scroll To Block Area
  $(document).on('click', "a[href*='#scroll-'], [data-element-link*='#scroll-']", function (evt) {
    const href = evt.currentTarget.getAttribute('href') ?? ''
    const [, id] = href.split('#scroll-')

    if (id) {
      if (isWithinCustomerCenterView()) {
        const el = document.querySelector(`.${id}`) as HTMLElement
        const mainElement = window.parent.document.body.querySelector('main')
        if (el && mainElement) {
          mainElement.scrollTo({ top: $(el).offset().top, behavior: 'smooth' })
        }
      } else {
        const el = document.querySelector(`.${id}`) as HTMLElement
        const popupParent = el?.closest('.modal-wrapper')
        const scrollContainer = popupParent || document.documentElement
        if (el && scrollContainer) {
          scrollContainer.scrollTo({ top: $(el).offset().top, behavior: 'smooth' })
        }
      }
    }

    return false
  })

  const getElementsIds = (evt, type) =>
    (evt.currentTarget.getAttribute(`data-${type}-button-ids`) || '').split(',').filter((s) => s)

  const performActionOnId = (id: string, action: 'fadeOut' | 'fadeIn') => {
    const $el = $(`.${id}`) as any
    if ($el.attr('data-show-only') && action === 'fadeIn') {
      $el.removeAttr('data-show-only')
      $el.css('display', 'none')
    }
    $el[action]({ duration: 500 })
  }

  // Show / Hide
  $(document).on('click', "a[href*='#show-hide'], [data-element-link*='#show-hide']", function (evt) {
    evt.preventDefault()

    const hideIds = getElementsIds(evt, 'hide')
    const showIds = getElementsIds(evt, 'show')

    hideIds.forEach((id) => performActionOnId(id, 'fadeOut'))
    showIds.forEach((id) => performActionOnId(id, 'fadeIn'))

    return false
  })

  // Do nothing for empty links
  $(document).on('click', "a[href=''], [data-element-link='']", function (evt) {
    evt.preventDefault()
    return false
  })

  $(document).on('click', '[data-element-link]', function (evt) {
    evt.preventDefault()
    const linkableElement = evt.currentTarget
    const link = linkableElement.getAttribute('data-element-link')
    if (link && !internalLinks.includes(link)) {
      const target = linkableElement.getAttribute('target') ?? '_self'
      if (target === '_self') {
        window.location.href = link
      } else {
        window.open(link, '_blank')
      }
    }
  })

  // Download File action — only fires in preview mode, where the page still holds
  // the raw sentinels (PublishService rewrites them to worker-signed /_cf2-download/
  // URLs at publish time). Preview is served on the workspace subdomain, same origin
  // as the admin interface, so we route to the auth-gated admin endpoint. Anonymous
  // viewers get bounced to login rather than being handed the file.
  $(document).on('click', "a[href^='#download-asset:']", function (evt) {
    evt.preventDefault()
    const id = evt.currentTarget.getAttribute('href').replace('#download-asset:', '')
    window.location.href = `/account/downloads/${id}/file`
    return false
  })

  $(document).on('click', "a[href^='#download-inline:']", function (evt) {
    evt.preventDefault()
    const id = evt.currentTarget.getAttribute('href').replace('#download-inline:', '')
    window.open(`/account/downloads/${id}/preview`, '_blank')
    return false
  })

  $(document).on('click', "a[href*='#no-link'], [data-element-link*='#no-link']", function (evt) {
    evt.preventDefault()
    const urlParams = new URLSearchParams(window.location.search)
    urlParams.set('next_funnel_step', 'true')
    window.location.href = `${window.location.pathname}?${urlParams}`
  })

  document.querySelectorAll('[data-element-link]').forEach((linkableElement) => {
    if (linkableElement.getAttribute('data-element-link')) linkableElement.setAttribute('tabindex', '0')
  })
}

window.addEventListener('DOMContentLoaded', setupActionLinkListeners)
